document.addEventListener('DOMContentLoaded', function () {
    function equalizeHeights() {
        var groupHeights = {};

        $('[data-eq-height-group]').each(function () {
            var $element = $(this);

            $element.css('height', '');
            
            var groupName = $element.attr('data-eq-height-group');
            var height = $element.height();

            if (!groupHeights[groupName]) {
                groupHeights[groupName] = 0;
            }

            groupHeights[groupName] = height > groupHeights[groupName] ? height : groupHeights[groupName];
        }).each(function () {
            var $element = $(this);
            var groupName = $element.attr('data-eq-height-group');
            $element.css('height', groupHeights[groupName] + 'px');
        });
    }

    $(window).on('resize', function() {
        equalizeHeights();
    });

    equalizeHeights();
});